import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------brand-listing--------------------------
export const questionListApi = async (data) => {
  const endPoint =
    `cms/get_onboarding_content` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// -------------------------update ----------------------------
export const adddOrUpdateQuestionApi = async (data) => {
  const endPoint = `cms/update_onboarding_content`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

export const adddOrUpdatePreTextApi = async (data) => {
  const endPoint = `cms/update_pre_login_data`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};
